/* tslint:disable */

declare var Object: any;
export interface RoleDataInterface {
  "code": number;
  "id"?: number;
  "name": string;
  "description"?: string;
  "created"?: Date;
  "modified"?: Date;
  principals?: any[];
  roles?: any[];
}

export class RoleData implements RoleDataInterface {
  "code": number;
  "id": number;
  "name": string;
  "description": string;
  "created": Date;
  "modified": Date;
  principals: any[];
  roles: any[];
  constructor(data?: RoleDataInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `RoleData`.
   */
  public static getModelName() {
    return "RoleData";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of RoleData for dynamic purposes.
  **/
  public static factory(data: RoleDataInterface): RoleData{
    return new RoleData(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'RoleData',
      plural: 'RoleData',
      path: 'RoleData',
      idName: 'id',
      properties: {
        "code": {
          name: 'code',
          type: 'number'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "name": {
          name: 'name',
          type: 'string'
        },
        "description": {
          name: 'description',
          type: 'string'
        },
        "created": {
          name: 'created',
          type: 'Date'
        },
        "modified": {
          name: 'modified',
          type: 'Date'
        },
      },
      relations: {
        principals: {
          name: 'principals',
          type: 'any[]',
          model: '',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'roleId'
        },
        roles: {
          name: 'roles',
          type: 'any[]',
          model: '',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'roleId'
        },
      }
    }
  }
}
